import { FormMode } from '@core/form/form.enums'
import { ColumnType } from '@shared/components/table/table.enums'
import { ColumnSetting } from '@shared/components/table/table.models'
import { FilterType } from '@shared/components/filters/filters.enums'
import { FilterSetting } from '@shared/components/filters/filters.models'
import { SelectionMode } from '@shared/components/calendar/calendar.enums'

import { FilterName, LicenseState } from './license.enums'

export const COLUMN_SETTINGS: ColumnSetting[] = [
  { field: 'id', translateHeader: 'MTR_COMMON_LICENSE_ID' },
  { field: 'hardwareId', translateHeader: 'MTR_COMMON_HARDWARE_ID' },
  { field: 'updateDate', translateHeader: 'MTR_COMMON_LAST_UPDATE', type: ColumnType.Date },
  { field: 'productName', translateHeader: 'MTR_COMMON_PRODUCT' },
  { field: 'expirationDate', translateHeader: 'MTR_COMMON_EXPIRATION_DATE', type: ColumnType.Date },
  {
    field: 'licenseStateKey',
    translateHeader: 'MTR_COMMON_LICENSE_STATUS',
    type: ColumnType.Custom,
  },
  { field: 'customerName', translateHeader: 'MTR_COMMON_CUSTOMER' },
  {
    field: 'requesterUser',
    translateHeader: 'MTR_COMMON_REQUESTER_USER',
    sortField: 'requesterName',
    type: ColumnType.Custom,
  },
  { field: 'remarks', translateHeader: 'MTR_COMMON_COMMENT' },
]

export const FILTER_SETTINGS: FilterSetting[] = [
  {
    id: FilterName.FreeText,
    type: FilterType.Text,
    label: 'MTR_COMMON_SEARCH',
    placeholder: 'MTR_SEARCH_FREETEXT_LICENSE',
  },
  {
    id: FilterName.CustomerId,
    type: FilterType.Dropdown,
    label: 'MTR_COMMON_CUSTOMER',
    placeholder: 'MTR_COMMON_CUSTOMER',
  },
  {
    id: FilterName.ProductId,
    type: FilterType.Dropdown,
    label: 'MTR_COMMON_PRODUCT',
    placeholder: 'MTR_COMMON_PRODUCT',
  },
  {
    id: FilterName.LicenseStateName,
    type: FilterType.Dropdown,
    label: 'MTR_COMMON_STATUS',
    placeholder: 'MTR_COMMON_STATUS',
    defaultValue: LicenseState.RenewalApplication,
    showClear: true,
  },
  {
    id: FilterName.ExpirationDate,
    type: FilterType.Date,
    selectionMode: SelectionMode.Range,
    label: 'MTR_COMMON_LICENSE_EXP',
  },
]

export const IsProcessRequest = (formMode) => [FormMode.ProcessRequest].includes(formMode)

export const LICENSE_STATE_TRANSLATION = {
  [LicenseState.Queued]: 'MTR_LICENSE_QUEUED',
  [LicenseState.Completed]: 'MTR_LICENSE_COMPLETED',
  [LicenseState.RenewalApplication]: 'MTR_LICENSE_RENEWAL_APPLICATION',
  [LicenseState.RenewalApproved]: 'MTR_LICENSE_RENEWAL_APPROVED',
  [LicenseState.RenewalV2CDownloaded]: 'MTR_LICENSE_RENEWAL_V2C_DOWNLOADED',
  [LicenseState.RenewalRejected]: 'MTR_LICENSE_RENEWAL_REJECTED',
  [LicenseState.Expired]: 'MTR_LICENSE_EXPIRED',
}
